import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const mediaUrl = (path) => (path && path.startsWith('/api') ? `${BACKEND_URL}${path}` : path);

const authHeaders = () => {
  const token = localStorage.getItem('atc_admin_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Auth
export const adminLogin = async (email, password) => {
  const res = await axios.post(`${API}/auth/login`, { email, password });
  localStorage.setItem('atc_admin_token', res.data.token);
  localStorage.setItem('atc_admin_user', JSON.stringify(res.data.user));
  return res.data;
};
export const adminLogout = () => {
  localStorage.removeItem('atc_admin_token');
  localStorage.removeItem('atc_admin_user');
};
export const getAdminUser = () => {
  try { return JSON.parse(localStorage.getItem('atc_admin_user')); } catch { return null; }
};
export const verifyAdmin = async () => {
  const res = await axios.get(`${API}/auth/me`, { headers: authHeaders() });
  return res.data;
};

// Public articles
export const fetchArticles = async (search = '', category = '') => {
  const res = await axios.get(`${API}/articles`, { params: { search, category } });
  return res.data;
};
export const fetchLatest = async () => (await axios.get(`${API}/articles/latest`)).data;
export const fetchCategories = async () => (await axios.get(`${API}/articles/categories`)).data;
export const fetchArticleBySlug = async (slug) => (await axios.get(`${API}/articles/slug/${slug}`)).data;

// Admin articles
export const adminListArticles = async () => (await axios.get(`${API}/admin/articles`, { headers: authHeaders() })).data;
export const adminGetArticle = async (id) => (await axios.get(`${API}/admin/articles/${id}`, { headers: authHeaders() })).data;
export const adminCreateArticle = async (data) => (await axios.post(`${API}/admin/articles`, data, { headers: authHeaders() })).data;
export const adminUpdateArticle = async (id, data) => (await axios.put(`${API}/admin/articles/${id}`, data, { headers: authHeaders() })).data;
export const adminDeleteArticle = async (id) => (await axios.delete(`${API}/admin/articles/${id}`, { headers: authHeaders() })).data;
export const adminUploadImage = async (file) => {
  const fd = new FormData();
  fd.append('file', file);
  const res = await axios.post(`${API}/admin/upload-image`, fd, { headers: { ...authHeaders(), 'Content-Type': 'multipart/form-data' } });
  return res.data;
};
